module.exports = __webpack_public_path__ + "static/img/hdw1.d7d16c77.jpg";